import { utils } from './utils.js';

class Navigation {

    constructor() {
    }

    init() {
        this.burgerMenu();
        this.dropDownMenu();
        this.clickHandler();
        this.communitiesHandler();

        this.priorityFirstNavigation();

        this.searchToggle();
    }

    /**
     * when the burger menu is clicked, activate the mobile menu
     */
    burgerMenu() {

        let self = this;
        let toggle = document.querySelector('.navigation-toggle .js-menu');

        if (toggle !== null) {

            let header = document.querySelector('#masthead');
            let navs = document.querySelector('.site-header .navigations');

            const handleClicks = function () {

                let te = event.target,
                    within = false; // clicked elements inside .navigation?

                do {
                    if (te == null) {
                        return;
                    }
                    // traverse up to the DOM until we get null
                    te = te.parentNode; // console.log( te  );
                    if (te != null) {
                        if (utils.hasClass(te, 'navigations')) {
                            // clicked elements within .navigations
                            within = true;
                            return;
                        }
                    }

                } while (te);

                if (!within) {
                    utils.toggleClass(header, 'js-menu-open');
                    utils.toggleClass(document.querySelector('body'), 'js-menu-open');
                    document.removeEventListener('click', handleClicks);
                }

            }

            // toggle.addEventListener('click', function(e) {
            //     utils.toggleClass( header, 'js-menu-open' );
            //     utils.toggleClass( document.querySelector('body'), 'js-menu-open' );
            // }, false);
            toggle.addEventListener('click', function (e) {
                e.stopPropagation();
                utils.toggleClass(header, 'js-menu-open');
                utils.toggleClass(document.querySelector('body'), 'js-menu-open');
                if (utils.hasClass(document.querySelector('body'), 'js-menu-open')) {
                    document.addEventListener('click', handleClicks);
                }
            });

        }
    }

    /**
     * when the drop down menu is clicked, allow the current target to be toggled yet close all other potentially opened menus
     */
    dropDownMenu() {

        let self = this;

        // @todo supply #primary-menu
        let children = document.querySelectorAll('.depth-0.menu-item-has-children > a'),
            subMenuContainers = document.querySelectorAll('.sub-menu-container');

        Array.prototype.forEach.call(children, function (el, i) {
            el.addEventListener('click', function (e) {
                e.preventDefault();
                let target = el.parentNode.querySelector('.sub-menu-container');
                let targetParent = el.parentNode;
                if (target !== null) {
                    Array.prototype.forEach.call(subMenuContainers, function (sm, j) {
                        if (targetParent.id === sm.parentNode.id) {
                            // toggle
                            utils.toggleClass(target, 'js-sub-menu-open');
                            utils.toggleClass(e.target, 'toggled');

                            // activate first community & its sites
                            //
                            let links = sm.querySelectorAll('.menu-item-object-cc_city a');
                            if (links.length > 0) {
                                let toActivate = links[0];
                                self.populateCommunitySites(toActivate);
                            }
                        } else {
                            // close other open menu
                            utils.removeClass(sm, 'js-sub-menu-open');
                            utils.removeClass(sm.previousSibling, 'toggled');
                        }
                    });
                }
            }, false);
        });
    }

    /**
     * listen for the click event on basically all nodes
     * this method is used to detect if we need to close the active drop down menu ( e.g. blur )
     */
    clickHandler() {

        let body = document.body;

        // @todo make a better click handler
        //
        let subMenuContainers = document.querySelectorAll('.sub-menu-container');

        document.body.parentNode.addEventListener('click', function (event) {

            // only trigger IF sub-menu-container is visible
            let proceed = false;
            Array.prototype.forEach.call(subMenuContainers, function (el, i) {

                if (utils.hasClass(el, 'js-sub-menu-open')) {
                    proceed = true;
                    return;
                }

            });

            if (!proceed) {
                // console.log('skipping.... no need to go further');
                return;
            }

            //     if (event.target.alt != 'Covenant Care') {
            //         event.preventDefault();
            //     }
            // }

            if (utils.hasClass(event.target.parentNode, 'menu-item-has-children')) {
                // console.log('keep going');
            } else {
                Array.prototype.forEach.call(subMenuContainers, function (el, i) {
                    let targetElement = event.target;
                    do {
                        if (targetElement == el) { // console.log('within menu');
                            return;
                        }
                        // traverse up to the DOM until we get null
                        targetElement = targetElement.parentNode;
                    } while (targetElement);

                    if (targetElement == null) {
                        // done traversing up, close the menu
                        utils.removeClass(el, 'js-sub-menu-open');
                        utils.removeClass(el.previousSibling, 'toggled');
                    }
                });
            }

        }, false);

    } // clickHandler

    /**
     * handle populating of List of Communities in the drop down menu
     * @todo finish implementing this!
     */
    communitiesHandler() {

        let self = this;

        let communityLinks = document.querySelectorAll('#primary-menu .menu-item-object-cc_city a'),
            subMenuExtra = document.querySelector('.communities .sub-menu-extra'),
            styles = subMenuExtra ? utils.getStyles(subMenuExtra) : null ;

        Array.prototype.forEach.call(communityLinks, function (el, i) {
            el.addEventListener('click', function (e) {
                if (styles.display != 'none') {
                    e.preventDefault();
                    self.populateCommunitySites(el);
                }
            });
        });

    } // communitiesHandler

    populateCommunitySites(toActivate) {

        let self = this;

        let el = toActivate, communityData = CovenantCare.communities,
            lis = el.parentNode.parentNode.querySelectorAll('.menu-item'),
            taxID = el.getAttribute('data-tax'),
            taxSlug = el.getAttribute('data-tax-slug'),
            tax = communityData[taxID]['city'],
            // container to populate the list of community sites
            target = document.querySelector('.communities .sub-menu-extra'); target.innerHTML = '';

        // reset
        Array.prototype.forEach.call(lis, function (li, k) {
            utils.removeClass(li, 'current-menu-item');
        });
        // set currently clicked item as .current-menu-item
        utils.addClass(el.parentNode, 'current-menu-item');

        let title = document.createElement('span'); utils.addClass(title, 'sub-menu-title');
        title.appendChild(document.createTextNode(tax.name + ' sites'));

        target.appendChild(title);

        let data = communityData[taxID]['communities'], // @todo ensure this array size is not zero
            ul = document.createElement('ul'); utils.addClass(ul, 'sub-menu'); // console.log( data );

        Array.prototype.forEach.call(data, function (ele, j) {
            var li = document.createElement('li');
            var a = document.createElement('a');
            a.href = ele.link;
            a.appendChild(document.createTextNode(ele.name));
            li.appendChild(a);
            ul.appendChild(li);
        });
        target.appendChild(ul);

        let seeAll = document.createElement('a'); seeAll.href = tax.link;
        seeAll.appendChild(document.createTextNode('See all ' + tax.name + ' sites'));

        target.appendChild(seeAll);

    } // populateCommunitySites

    /**
     * adaptation of https://codepen.io/lukejacksonn/pen/BowbWE in plain JS
     */
    priorityFirstNavigation() {

        let self = this;

        // list-of-x -taxonomy -category
        let nav = document.querySelector('.list-of-x');
        if (nav == null) {
            return;
        }

        let mlinks = document.querySelector('.list-of-x .more-link'), // wheret the button is
            btn = document.querySelector('.more-link button'),
            vlinks = document.querySelector('.links'),
            hlinks = document.querySelector('.hidden-links'),
            numOfItems = 0,
            totalSpace = 0,
            breakWidths = [];

        // get the initial state
        Array.prototype.forEach.call(vlinks.children, function (el, j) {
            totalSpace += el.offsetWidth;
            numOfItems += 1;
            breakWidths.push(totalSpace);
        });

        let availableSpace, numOfVisibleItems, requiredSpace;

        function check() {

            // Get instant state
            availableSpace = vlinks.clientWidth - 10;
            numOfVisibleItems = vlinks.children.length;
            requiredSpace = breakWidths[numOfVisibleItems - 1];

            if (requiredSpace > availableSpace) {

                hlinks.insertBefore(
                    vlinks.children[vlinks.children.length - 2],
                    hlinks.childNodes[0] || null
                );
                numOfVisibleItems -= 1;
                check();

            } else if (availableSpace > breakWidths[numOfVisibleItems]) {

                // There is more than enough space
                //
                // reinject back before the last item, which is the More button
                vlinks.insertBefore(hlinks.children[0] || null, vlinks.children[vlinks.children.length - 1]);
                numOfVisibleItems += 1;

            } else {

            }

            // Update the button accordingly
            //
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                utils.toggleClass(hlinks, 'hidden');
                utils.toggleClass(btn, 'toggled');
            });

            // on load / resize
            //
            if (numOfVisibleItems == numOfItems) {
                utils.removeClass(mlinks, 'shown');
            } else {
                utils.addClass(mlinks, 'shown');
            }

        }

        check();

        window.addEventListener('resize', utils.debounce(function () { check(); }, 50));

    } // priorityFirstNavigation

    doIt() {
        let self = this;
    }

    searchToggle() {

        let self = this;

        let toggle = document.querySelector('#secondary-menu .search-box-toggle a'),
            search = document.querySelector('.search-box');
        if (toggle == null) {
            return;
        }
        toggle.addEventListener('click', function (e) {
            e.preventDefault();
            utils.toggleClass(search, 'shown');
            // @todo focus once it is open
        });

    }

} // class Navigation

// Singleton
export let navigation = new Navigation();